// imports
import { openModal, closeModal } from '../utils/modal';

const header = document.getElementById('header');
const mainMenu = header.querySelector(
  '.menu-main-mobile .main__items--level-0',
);
// we're using two different overlay elements,
// header has own, bc of z-index issues
const overlay = header.querySelector('.modal-overlay--header');

const headerMenuOpen = 'header--mobile-menu-open';
const headerSubmenuOpen = 'header--submenu-open'; // takes case of showing submenu
const menuItemOpenSubmenu = 'menu-item--open-submenu';
const mobileMenuToggleIcon = 'header-main__menu-toggle';
const modalMenuMobile = 'modal--menu-mobile';

let mobileMenuOpen = false;
let subMenuOpen = false;

const mobileMenuToggle = () => {
  const modalTrigger = header.querySelector(`.${mobileMenuToggleIcon}`);
  const modal = header.querySelector(`.${modalMenuMobile}`);

  modalTrigger.addEventListener('click', () => {
    openModal(modal, overlay);

    // update global variables
    mobileMenuOpen = true;

    // update classes
    header.classList.add(headerMenuOpen);
  });
};

const handleMenuClick = (event) => {
  const { target } = event;
  const firstLevelLinkClass = [
    'main__link--level-0',
    'main__link--has-children',
  ];
  const linkHasChildren = firstLevelLinkClass.every((cName) =>
    target.classList.contains(cName),
  );

  if (linkHasChildren) {
    event.stopImmediatePropagation();
    event.preventDefault();

    // show submenu
    header.classList.add(headerSubmenuOpen);

    // add submenu title string
    const modalHeaderPlaceholder = header.querySelector(
      '.menu-main-mobile__placeholder',
    );
    modalHeaderPlaceholder.innerHTML = target.textContent.trim();

    // add class to active children menu
    target.parentNode.classList.add(menuItemOpenSubmenu);

    subMenuOpen = true;
  }
};

const mobileChildrenToggle = () => {
  mainMenu?.addEventListener('click', handleMenuClick);
};

// @todo can probably move to utils at some point
const handleCloseEvents = () => {
  window.addEventListener('click', (event) => {
    const { target } = event;
    event.stopImmediatePropagation();

    const modal = header.querySelector(`.${modalMenuMobile}`);

    // abort if we clicked modal trigger or inside the modal
    const modalContent = modal.querySelector('.modal__content');
    if (
      modalContent.contains(target) ||
      target.classList.contains(mobileMenuToggleIcon)
    ) {
      return;
    }

    const onOverlay = target.classList.contains('modal-overlay--header');
    const onCloseIcon = target.classList.contains('modal__close');

    // close all right away if click on overlay
    // @todo make DRY
    if (onOverlay) {
      // hide submenu & go back to 0th level menu
      if (subMenuOpen) {
        header.classList.remove(headerSubmenuOpen);
        header
          .querySelector(`.${menuItemOpenSubmenu}`)
          .classList.remove(menuItemOpenSubmenu);

        subMenuOpen = false;
      }

      // hide mobile modal
      if (mobileMenuOpen) {
        closeModal(modal, overlay);
        header.classList.remove(headerMenuOpen);
        mobileMenuOpen = false;
      }
    } else if (subMenuOpen) {
      // hide submenu & go back to 0th level menu
      header.classList.remove(headerSubmenuOpen);
      header
        .querySelector(`.${menuItemOpenSubmenu}`)
        .classList.remove(menuItemOpenSubmenu);

      subMenuOpen = false;
    } else if (onCloseIcon) {
      // hide mobile modal
      closeModal(modal, overlay);
      header.classList.remove(headerMenuOpen);

      mobileMenuOpen = false;
    }
  });
};

const initMobileMenuInteractions = () => {
  mobileMenuToggle();
  // click events for links with children
  mobileChildrenToggle();
  // listen for clicks on items that should close menus
  handleCloseEvents();
};

(() => {
  if (header) {
    initMobileMenuInteractions();
  }
})();
